import React from "react";
import Hero from "./Hero";

function HeaderSection() {
  return <Hero />;
}
export default HeaderSection;
